<template>
  <div>
    <b-row>
      <b-col>
        <search-box v-model="query" />
      </b-col>
      <b-col class="text-right">
        <b-button
          v-if="auth.user.selectedAccess.roleLevel > 3"
          v-router-link="{ name: 'distributor-editor' }"
          variant="outline-primary"
        >
          <!-- <b-button v-if="auth.user.selectedAccess.roleLevel === 4 && auth.user.selectedAccess.can_modify_settings" v-router-link="{name:'distributor-editor'}" variant="outline-primary"> -->
          <span v-label-key="'ADD_DISTRIBUTOR'">Add distributor</span>
        </b-button>
      </b-col>
    </b-row>
    <b-table
      id="distributor-table"
      ref="distributorTable"
      :per-page="0"
      :current-page="currentPage"
      :items="distributors"
      :fields="fields"
      :busy="loading"
      show-empty
      striped
      hover
      responsive
      @sort-changed="handleSortChange"
    >
      <template v-slot:cell(name)="data">
        <router-link :to="{ name: 'distributor-detail', params: data.item }">
          {{ data.item.name }}
        </router-link>
      </template>
      <template v-slot:table-busy>
        <loading-spinner />
      </template>
    </b-table>
    <b-pagination
      v-model="currentPage"
      :total-rows="total"
      :per-page="perPage"
      align="right"
      aria-controls="distributor-table"
      @change="pageChanged"
    />
  </div>
</template>

<script>
import debounce from 'lodash.debounce';
import $api from '@/services/api';
import $auth from '@/services/auth';
import $search from '@/services/search';
import LoadingSpinner from '@/components/LoadingSpinner';
import SearchBox from '@/components/SearchBox';
import { mapGetters } from 'vuex';

export default {
  name: 'DistributorList',
  components: {
    LoadingSpinner,
    SearchBox,
  },
  computed: {
    ...mapGetters('translations', {
      getLabel: 'getLabel',
    }),
    fields() {
      return [
        { key: 'id', label: this.getLabel('ID'), sortable: true },
        { key: 'name', label: this.getLabel('NAME'), sortable: true },
      ];
    },

    totalRows() {
      return (
        this.distributors &&
        this.search(this.distributors, this.query, ['name']).length
      );
    },
  },
  data() {
    return {
      auth: $auth,
      search: $search,
      query: null,
      distributors: [],
      perPage: 10,
      currentPage: 1,
      total: 0,
      orderBy: '',
      isOrderByDesc: false,
      loading: false,
    };
  },
  watch:{
    query(newValue) {
      this.debounceSearch(newValue);
    }
  },
  beforeDestroy() {
    if (this.debounceSearch && this.debounceSearch.cancel) {
      this.debounceSearch.cancel();
    }
  },
  created() {
    this.debounceSearch = debounce(() => {
      this.currentPage = 1;
      this.refreshData();
    }, 500);

    this.refreshData();
  },
  methods: {
    pageChanged(page) {
      this.currentPage = page;
      this.refreshData();
    },
    handleSortChange(e){
      this.orderBy = e.sortBy;
      this.isOrderByDesc = e.sortDesc;
      this.refreshData();
    },
    refreshData() {
      this.loading = true;
      this.distributors = [];

      let tempQuery = this.getListQuery();

      tempQuery += `&skip=${(this.currentPage - 1) * this.perPage}&take=${
        this.perPage
      }`;
 
      $api
        .get('/v1/dashboard/distributors' + tempQuery)
        .then(response => {
          this.distributors = response.data;
          this.total = response.total;
          this.$emit('loaded', response.data);
        })
        .catch(() => {
        }).finally(() => {
          this.loading = false;
          this.$refs.distributorTable.refresh();
        });
    },
    getListQuery() {
      const payload = {
        orderBy: this.orderBy? this.orderBy : null,
        isOrderByDesc: this.orderBy ? this.isOrderByDesc : null,
        searchKey: this.query ? this.query : null,
      };

      let tempQuery = "?";
      for (const key in payload) {
        if (payload[key] !== null && payload[key] !== undefined) {
          tempQuery += `&${key}=${payload[key]}`;
        }
      }

      return tempQuery;
    },
  },
};
</script>
<style scoped>
a {
  color: black;
}
</style>
